export function randomId() {
    return `${Date.now()}x${1000000000 * Math.random() | 0}`;
}
